import { render, staticRenderFns } from "./modal-confirm-remove-product.vue?vue&type=template&id=32fa7a54&"
import script from "./modal-confirm-remove-product.vue?vue&type=script&lang=js&"
export * from "./modal-confirm-remove-product.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports